const disclaimers = [
  {
    icon: "ri-file-info-line",
    title: "内容性质",
    desc: "本站仅围绕大师兄影视的入口与地址相关概念做信息整理与说明，不提供任何在线播放、下载或影视资源存储服务。",
  },
  {
    icon: "ri-shield-keyhole-line",
    title: "信息核对",
    desc: "页面中的说明为通用性描述，具体地址与访问方式请以发布页同步的信息为准，并对来源进行基本核对后再访问。",
  },
  {
    icon: "ri-user-heart-line",
    title: "浏览建议",
    desc: "请遵守所在地的相关规定，理性浏览、安全上网。遇到可疑页面时及时停止操作，避免造成不必要的损失。",
  },
];

export default function DisclaimerSection() {
  return (
    <section id="disclaimer" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 px-3 py-1 text-xs font-label rounded-full bg-secondary-100 text-secondary-900 border border-secondary-200">
            <i className="ri-shield-check-line" />
            安全与免责声明
          </span>
          <h2 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            使用本站前，请先了解这几点
          </h2>
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4">
          {disclaimers.map((d) => (
            <article
              key={d.title}
              className="p-5 md:p-6 rounded-lg bg-background-100 border border-background-200"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className={`${d.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{d.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{d.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}